// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ForSorting_checkbox__9txSm","checkedCheckbox":"ForSorting_checkedCheckbox__3RqDL","sortingBox":"ForSorting_sortingBox__1G0iS"};